import { defineStore } from 'pinia';

export const useInitialLoadingStore = defineStore('splashScreenStore', 
{
    state: () =>
    ({
        showInitialLoading: false
    }),
    actions:
    {
        show(): void
        {
            this.showInitialLoading = true;
        },
        hide(): void
        {
            this.showInitialLoading = false;
        }
    }
});